import React from 'react';
import cx from 'classnames';

import { IconErrorCircle, IconWarningSign, IconInfoCircle } from '../..';

interface Props {
    canceled?: boolean;
    errorStyle: 'loud' | 'quiet';
    handleCancel?(): void;
    handleExpandError?(): void;
    handleNeedHelp?(): void;
    handleTryAgain?(): void;
    Icon?: IconComponent;
    label: string;
    labelLines: 1 | 2;
    width: number;
}

const colorMap = {
    loud: {
        light: 'quinary-400',
        dark: 'quinary-500',
    },
    quiet: {
        light: 'tertiary-400',
        dark: 'tertiary-400',
    },
};

export const ErrorBar = ({
    canceled,
    errorStyle,
    handleCancel,
    handleExpandError,
    Icon = IconWarningSign,
    label,
    labelLines,
    width,
}: Props): JSX.Element => {
    const { light, dark } = colorMap[errorStyle];

    return (
        <div style={{ width }}>
            <div
                className="grid gap-2 px-4"
                style={{
                    gridTemplateColumns: '24px auto 120px 13px',
                }}
            >
                <div className="justify-self-auto flex justify-center items-center">
                    <Icon fillColor={light} width={24} />
                </div>
                <div
                    className={cx(
                        'justify-self-stretch self-center',
                        `text-${light}`,
                        {
                            truncate: labelLines === 1,
                            'clamp-2-lines': labelLines === 2,
                        },
                    )}
                >
                    {label}
                </div>
                <div className="justify-self-auto flex justify-center items-center">
                    {handleExpandError && (
                        <button
                            type="button"
                            className={`text-${dark} px-1 text-sm leading-tight underline respond-to-mouse`}
                            onClick={handleExpandError}
                        >
                            <div
                                className="grid place-items-start"
                                style={{
                                    gridTemplateColumns: '20px 100px',
                                }}
                            >
                                <IconInfoCircle
                                    addClasses="mr-1"
                                    fillColor={dark}
                                    width={20}
                                />
                                <div>Something&lsquo;s wrong</div>
                            </div>
                        </button>
                    )}
                </div>
                <div className="justify-self-auto flex justify-center items-center">
                    {!canceled && handleCancel && (
                        <button
                            type="button"
                            className="px-1 respond-to-mouse font-bold underline"
                            onClick={handleCancel}
                        >
                            <IconErrorCircle width={13} fillColor="black" />
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};
